import service from "../service";

export const getSettingsService = () => (
  service('get', `v3/ajustes`)
)

export const updateSettingsService = (idSettings, data) => (
  service('post', `v3/ajustes/${idSettings}`, { data })
)
